
export const ProfilerQuestionID = {
	// Business
	INDUSTRY: 'industry',

	// FMCG
	FMCG_SUB_INDUSTRY: 'fmcg_sub_industry',
	FMCG_BRAND_NUMBERS: 'fmcg_brand_numbers',
	FMCG_TURNOVER: 'fmcg_turnover',
	FMCG_STORE_TYPE: 'fmcg_store_type',
	FMCG_FROZEN_FOODS: 'fmcg_frozen_foods',

	// BCM
	BCM_SUB_INDUSTRY: 'bcm_sub_industry',
	BCM_BRAND_NAME: 'bcm_brand_name',
	BCM_TURNOVER: 'bcm_turnover',

	// Common
	NEXT_GEN: "next_gen_participation",

	// Personal Profiler
	PREFERRED_LANGUAGE: 'preferred_language',
	MARITAL_STATUS: 'marital_status',
	MARRIAGE_ANNIVERSARY: 'marriage_anniversary',
	SPOUSE_BUSINESS_INVOLVEMENT: 'spouse_business_involvement',
	KIDS_COUNT: 'kids_count',
	KIDS_EDUCATION_COUNT: 'kids_education_count',
	PREFERRED_HOLIDAY_DESTINATION: 'preferred_holiday_destination',
	PREFERRED_DOMESTIC_DESTINATION: 'preferred_domestic_destination',
	PREFERRED_INTERNATIONAL_DESTINATION: 'preferred_international_destination',

	INSURANCE_INTEREST: 'insurance_opt_in',
};
